import script from "./DVSStep4Resumen.vue?vue&type=script&setup=true&lang=js"
export * from "./DVSStep4Resumen.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__